/* KORA CUSTOM START - desktop mega menu */

const menuSelector = '[data-kora-menu]';
const initializedAttribute = 'data-kora-menu-ready';

function normalizeSearchText(value) {
  return value
    .normalize('NFD')
    .replace(/\p{Diacritic}/gu, '')
    .toLocaleLowerCase('it');
}

function initAlphabeticalSearch(item) {
  const search = item.querySelector('[data-kora-alphabetical-search]');
  const list = item.querySelector('[data-kora-alphabetical-list]');
  const empty = item.querySelector('[data-kora-alphabetical-empty]');

  if (!(search instanceof HTMLInputElement) || !list || !empty) return;

  search.addEventListener('input', () => {
    const query = normalizeSearchText(search.value.trim());
    let visibleLinkCount = 0;

    list.querySelectorAll('[data-kora-alphabetical-group]').forEach((group) => {
      let visibleGroupLinkCount = 0;

      group.querySelectorAll('[data-kora-alphabetical-link]').forEach((link) => {
        const label = normalizeSearchText(link.dataset.searchLabel || link.textContent || '');
        const matches = label.includes(query);

        link.closest('.kora-menu__subitem')?.toggleAttribute('hidden', !matches);
        if (matches) visibleGroupLinkCount += 1;
      });

      group.toggleAttribute('hidden', visibleGroupLinkCount === 0);
      visibleLinkCount += visibleGroupLinkCount;
    });

    list.toggleAttribute('hidden', visibleLinkCount === 0);
    empty.toggleAttribute('hidden', visibleLinkCount > 0);
  });
}

function setExpanded(item, expanded) {
  const trigger = item.querySelector('[data-kora-menu-trigger]');
  const dropdown = item.querySelector('[data-kora-menu-dropdown]');

  if (!trigger || !dropdown) return;

  item.classList.toggle('is-open', expanded);
  trigger.setAttribute('aria-expanded', expanded ? 'true' : 'false');
}

function closeSiblingItems(currentItem) {
  const menu = currentItem.closest(menuSelector);
  const items = menu?.querySelectorAll('[data-kora-menu-item]');

  items?.forEach((item) => {
    if (item !== currentItem) setExpanded(item, false);
  });
}

function closeMenu(menu) {
  menu.querySelectorAll('[data-kora-menu-item]').forEach((item) => {
    setExpanded(item, false);
  });
}

function initKoraMenu(menu) {
  if (menu.hasAttribute(initializedAttribute)) return;

  menu.setAttribute(initializedAttribute, 'true');

  menu.querySelectorAll('[data-kora-menu-item]').forEach((item) => {
    const trigger = item.querySelector('[data-kora-menu-trigger]');

    if (!trigger) return;

    initAlphabeticalSearch(item);

    item.addEventListener('pointerenter', () => {
      closeSiblingItems(item);
      setExpanded(item, true);
    });

    item.addEventListener('pointerleave', () => {
      setExpanded(item, false);
    });

    item.addEventListener('focusin', () => {
      closeSiblingItems(item);
      setExpanded(item, true);
    });

    item.addEventListener('focusout', (event) => {
      if (event.relatedTarget instanceof Node && item.contains(event.relatedTarget)) return;
      setExpanded(item, false);
    });
  });

  menu.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;

    closeMenu(menu);

    if (event.target instanceof Element) {
      event.target.closest('[data-kora-menu-item]')?.querySelector('[data-kora-menu-trigger]')?.focus();
    }
  });

  document.addEventListener('pointerdown', (event) => {
    if (event.target instanceof Node && menu.contains(event.target)) return;
    closeMenu(menu);
  });
}

function initKoraMenus() {
  document.querySelectorAll(menuSelector).forEach(initKoraMenu);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initKoraMenus);
} else {
  initKoraMenus();
}

document.addEventListener('shopify:section:load', initKoraMenus);

/* KORA CUSTOM END - desktop mega menu */
